import api from '@ibkr/clientportal.common/src/api/iserverApi.js'
import hmdsApi from '@ibkr/clientportal.common/src/api/hmdsApi'
import { progressStart, progressEnd } from '@ibkr/lib.common/src/js/progress'
import { safeCall } from '@ibkr/clientportal.common/src/js/promise'
import { httpFailed, httpStatus, httpError, getHttpErrorReason } from '@ibkr/clientportal.common/src/js/http'

const actions = {
    postScannerQuery({ commit, dispatch, state, rootGetters }, { instrument, type, filter,
        location, delayedLocations, secType, maxItems, size=50, el, onSuccess, onError }) {
        progressStart(el);
        if (rootGetters["abFeatures/showDirectHMDS"]) {
            hmdsApi.postScannerQuery(instrument, type, filter, location, delayedLocations, secType, maxItems).then((res) => {
                safeCall('post scanner query', onSuccess, res);
                progressEnd(el);
            })
            .catch((result) => {
                progressEnd(el);
                safeCall('post scanner query', onError, result);
                httpFailed('post scanner query', commit, result);
            });
        } else {
            api.postScannerQuery(instrument, type, filter, location, size).then((res) => {
                safeCall('post scanner query', onSuccess, res);
                progressEnd(el);
            })
            .catch((result) => {
                progressEnd(el);
                safeCall('post scanner query', onError, result);
                httpFailed('post scanner query', commit, result);
            });
        }
    }
}

export default {
    namespaced: true,
    actions
}
